module.exports = __webpack_public_path__ + "905a013538654393552db56acd5b2866.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-startup.jpg
// module id = 128
// module chunks = 0